"use client";

import { useState } from "react";
import { useAuth } from "@/lib/auth/context";
import { useWeeklyRecap } from "@/lib/hooks/useWeeklyRecap";
import { isInRecapWindow } from "@/lib/utils/ritualWindows";
import { FridayRecapSheet } from "./FridayRecapSheet";

type Props = {
  /** Bardziej zwarty layout (bez chevronu, mniejsze padding) — gdy stoi
      obok innego banneru w gridzie 2-kolumnowym. */
  compact?: boolean;
};

export function RitualBanner({ compact = false }: Props = {}) {
  const { userDoc, firebaseUser } = useAuth();
  const hid = userDoc?.householdId;
  const recap = useWeeklyRecap(hid, firebaseUser?.uid);
  const [open, setOpen] = useState(false);

  if (!isInRecapWindow()) return null;
  if (recap.loading) return null;
  if (!recap.hasAnyData) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={
          compact
            ? "w-full flex items-center gap-2 rounded-[16px] border border-hay-bd px-3 py-2 text-left transition-[transform] active:translate-y-px"
            : "w-full flex items-center gap-3 rounded-[16px] border border-hay-bd px-3.5 py-2.5 text-left transition-[transform,box-shadow] active:translate-y-px"
        }
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(255,201,60,0.25), rgba(255,201,60,0.08))",
        }}
      >
        <div className={compact ? "text-[18px] leading-none shrink-0" : "text-[22px] leading-none shrink-0"}>🌟</div>
        <div className="flex-1 min-w-0">
          <div className={compact ? "text-[12px] font-bold text-navy leading-tight truncate" : "text-[13px] font-bold text-navy leading-tight"}>
            {recap.title}
          </div>
          <div className={compact ? "text-[10px] text-muted truncate" : "text-[11px] text-muted mt-0.5 truncate"}>
            Zobacz podsumowanie
          </div>
        </div>
        {compact ? null : <div className="text-muted text-lg leading-none shrink-0">›</div>}
      </button>
      <FridayRecapSheet open={open} onClose={() => setOpen(false)} recap={recap} />
    </>
  );
}
